import React from 'react';
import { motion } from 'framer-motion';

const FounderSection = () => (
  <section className="py-20 border-t" style={{ background: '#0d0d0d', borderColor: '#1a1a1a' }}>
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>How We Work</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: '#f1f1f1' }}>
          Built and configured with you,<br className="hidden md:block" /> not thrown over the wall.
        </h2>
        <p className="text-base leading-relaxed mb-5" style={{ color: '#888' }}>
          Valtivo is implemented hands-on. We help scope the workflow, configure the logic, test the experience, and refine the handoff so the system works in the real world — not just in a demo.
        </p>
        <p className="text-base leading-relaxed" style={{ color: '#888' }}>
          You work directly with the founder during implementation and onboarding. After go-live, we review performance monthly and make adjustments as your call patterns evolve.
        </p>
      </motion.div>
    </div>
  </section>
);

export default FounderSection;